/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiSectorCreateSectorPost } from '../fn/sector/api-sector-create-sector-post';
import { ApiSectorCreateSectorPost$Params } from '../fn/sector/api-sector-create-sector-post';
import { apiSectorCreateSectorPost$Plain } from '../fn/sector/api-sector-create-sector-post-plain';
import { ApiSectorCreateSectorPost$Plain$Params } from '../fn/sector/api-sector-create-sector-post-plain';
import { apiSectorDeleteSectorDelete } from '../fn/sector/api-sector-delete-sector-delete';
import { ApiSectorDeleteSectorDelete$Params } from '../fn/sector/api-sector-delete-sector-delete';
import { apiSectorDeleteSectorDelete$Plain } from '../fn/sector/api-sector-delete-sector-delete-plain';
import { ApiSectorDeleteSectorDelete$Plain$Params } from '../fn/sector/api-sector-delete-sector-delete-plain';
import { apiSectorGetAllSectorsGet } from '../fn/sector/api-sector-get-all-sectors-get';
import { ApiSectorGetAllSectorsGet$Params } from '../fn/sector/api-sector-get-all-sectors-get';
import { apiSectorGetAllSectorsGet$Plain } from '../fn/sector/api-sector-get-all-sectors-get-plain';
import { ApiSectorGetAllSectorsGet$Plain$Params } from '../fn/sector/api-sector-get-all-sectors-get-plain';
import { apiSectorGetSectorGet } from '../fn/sector/api-sector-get-sector-get';
import { ApiSectorGetSectorGet$Params } from '../fn/sector/api-sector-get-sector-get';
import { apiSectorGetSectorGet$Plain } from '../fn/sector/api-sector-get-sector-get-plain';
import { ApiSectorGetSectorGet$Plain$Params } from '../fn/sector/api-sector-get-sector-get-plain';
import { apiSectorUpdateSectorPatch } from '../fn/sector/api-sector-update-sector-patch';
import { ApiSectorUpdateSectorPatch$Params } from '../fn/sector/api-sector-update-sector-patch';
import { apiSectorUpdateSectorPatch$Plain } from '../fn/sector/api-sector-update-sector-patch-plain';
import { ApiSectorUpdateSectorPatch$Plain$Params } from '../fn/sector/api-sector-update-sector-patch-plain';
import { CreateSectorCommandResult } from '../models/create-sector-command-result';
import { DeleteSectorCommandResult } from '../models/delete-sector-command-result';
import { GetSectorQueryResult } from '../models/get-sector-query-result';
import { GetSectorsQueryResult } from '../models/get-sectors-query-result';
import { UpdateSectorCommandResult } from '../models/update-sector-command-result';

@Injectable({ providedIn: 'root' })
export class SectorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSectorGetSectorGet()` */
  static readonly ApiSectorGetSectorGetPath = '/api/Sector/GetSector';

  /**
   * Retrieves a specific sector by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorGetSectorGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetSectorGet$Plain$Response(params?: ApiSectorGetSectorGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSectorQueryResult>> {
    return apiSectorGetSectorGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific sector by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorGetSectorGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetSectorGet$Plain(params?: ApiSectorGetSectorGet$Plain$Params, context?: HttpContext): Observable<GetSectorQueryResult> {
    return this.apiSectorGetSectorGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSectorQueryResult>): GetSectorQueryResult => r.body)
    );
  }

  /**
   * Retrieves a specific sector by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorGetSectorGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetSectorGet$Response(params?: ApiSectorGetSectorGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSectorQueryResult>> {
    return apiSectorGetSectorGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific sector by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorGetSectorGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetSectorGet(params?: ApiSectorGetSectorGet$Params, context?: HttpContext): Observable<GetSectorQueryResult> {
    return this.apiSectorGetSectorGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSectorQueryResult>): GetSectorQueryResult => r.body)
    );
  }

  /** Path part for operation `apiSectorGetAllSectorsGet()` */
  static readonly ApiSectorGetAllSectorsGetPath = '/api/Sector/GetAllSectors';

  /**
   * Retrieves all sectors with filtering and pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorGetAllSectorsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetAllSectorsGet$Plain$Response(params?: ApiSectorGetAllSectorsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSectorsQueryResult>> {
    return apiSectorGetAllSectorsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all sectors with filtering and pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorGetAllSectorsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetAllSectorsGet$Plain(params?: ApiSectorGetAllSectorsGet$Plain$Params, context?: HttpContext): Observable<GetSectorsQueryResult> {
    return this.apiSectorGetAllSectorsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSectorsQueryResult>): GetSectorsQueryResult => r.body)
    );
  }

  /**
   * Retrieves all sectors with filtering and pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorGetAllSectorsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetAllSectorsGet$Response(params?: ApiSectorGetAllSectorsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSectorsQueryResult>> {
    return apiSectorGetAllSectorsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all sectors with filtering and pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorGetAllSectorsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSectorGetAllSectorsGet(params?: ApiSectorGetAllSectorsGet$Params, context?: HttpContext): Observable<GetSectorsQueryResult> {
    return this.apiSectorGetAllSectorsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSectorsQueryResult>): GetSectorsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiSectorCreateSectorPost()` */
  static readonly ApiSectorCreateSectorPostPath = '/api/Sector/CreateSector';

  /**
   * Creates a new sector.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorCreateSectorPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorCreateSectorPost$Plain$Response(params?: ApiSectorCreateSectorPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSectorCommandResult>> {
    return apiSectorCreateSectorPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new sector.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorCreateSectorPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorCreateSectorPost$Plain(params?: ApiSectorCreateSectorPost$Plain$Params, context?: HttpContext): Observable<CreateSectorCommandResult> {
    return this.apiSectorCreateSectorPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateSectorCommandResult>): CreateSectorCommandResult => r.body)
    );
  }

  /**
   * Creates a new sector.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorCreateSectorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorCreateSectorPost$Response(params?: ApiSectorCreateSectorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSectorCommandResult>> {
    return apiSectorCreateSectorPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new sector.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorCreateSectorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorCreateSectorPost(params?: ApiSectorCreateSectorPost$Params, context?: HttpContext): Observable<CreateSectorCommandResult> {
    return this.apiSectorCreateSectorPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateSectorCommandResult>): CreateSectorCommandResult => r.body)
    );
  }

  /** Path part for operation `apiSectorUpdateSectorPatch()` */
  static readonly ApiSectorUpdateSectorPatchPath = '/api/Sector/UpdateSector';

  /**
   * Updates an existing sector.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorUpdateSectorPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorUpdateSectorPatch$Plain$Response(params?: ApiSectorUpdateSectorPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSectorCommandResult>> {
    return apiSectorUpdateSectorPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing sector.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorUpdateSectorPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorUpdateSectorPatch$Plain(params?: ApiSectorUpdateSectorPatch$Plain$Params, context?: HttpContext): Observable<UpdateSectorCommandResult> {
    return this.apiSectorUpdateSectorPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateSectorCommandResult>): UpdateSectorCommandResult => r.body)
    );
  }

  /**
   * Updates an existing sector.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorUpdateSectorPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorUpdateSectorPatch$Response(params?: ApiSectorUpdateSectorPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSectorCommandResult>> {
    return apiSectorUpdateSectorPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing sector.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorUpdateSectorPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorUpdateSectorPatch(params?: ApiSectorUpdateSectorPatch$Params, context?: HttpContext): Observable<UpdateSectorCommandResult> {
    return this.apiSectorUpdateSectorPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateSectorCommandResult>): UpdateSectorCommandResult => r.body)
    );
  }

  /** Path part for operation `apiSectorDeleteSectorDelete()` */
  static readonly ApiSectorDeleteSectorDeletePath = '/api/Sector/DeleteSector';

  /**
   * Deletes a sector by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorDeleteSectorDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorDeleteSectorDelete$Plain$Response(params?: ApiSectorDeleteSectorDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteSectorCommandResult>> {
    return apiSectorDeleteSectorDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a sector by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorDeleteSectorDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorDeleteSectorDelete$Plain(params?: ApiSectorDeleteSectorDelete$Plain$Params, context?: HttpContext): Observable<DeleteSectorCommandResult> {
    return this.apiSectorDeleteSectorDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteSectorCommandResult>): DeleteSectorCommandResult => r.body)
    );
  }

  /**
   * Deletes a sector by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSectorDeleteSectorDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorDeleteSectorDelete$Response(params?: ApiSectorDeleteSectorDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteSectorCommandResult>> {
    return apiSectorDeleteSectorDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a sector by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSectorDeleteSectorDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSectorDeleteSectorDelete(params?: ApiSectorDeleteSectorDelete$Params, context?: HttpContext): Observable<DeleteSectorCommandResult> {
    return this.apiSectorDeleteSectorDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteSectorCommandResult>): DeleteSectorCommandResult => r.body)
    );
  }

}
